import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AppProvider } from './context/AppContext';
import { AuthProvider } from './context/AuthContext';
import HomePage from './components/pages/HomePage';
import CatalogPage from './components/pages/CatalogPage';
import ProductPage from './components/pages/ProductPage';
import CartPage from './components/pages/CartPage';
import UserInfoPage from './components/pages/UserInfoPage';
import AuthPage from './components/pages/AuthPage';
import InformationPage from './components/pages/InformationPage';
import NavBar from './components/common/NavBar';
import './index.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppProvider>
          <ToastContainer position="top-right" autoClose={3000} theme="colored" />
          <NavBar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/catalog" element={<CatalogPage />} />
            <Route path="/product/:id" element={<ProductPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/account" element={<UserInfoPage />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/information" element={<InformationPage />} />
          </Routes>
        </AppProvider>
      </AuthProvider>
    </Router>
  );
}
export default App;
